/* eslint-disable */
import React, { useState, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import {
  Table,
  TableContainer,
  TablePagination,
  TableSortLabel,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Button,
} from '@mui/material'

// helpers
import { sortGroups } from './groupsList.helpers'

// css styles
import styles from './groupsList.module.scss'

const editStyle = {
  width: '184px',
  backgroundColor: '#eb1700',
  '&:hover': {
    backgroundColor: '#CC1400',
  },
  '&:disabled': {
    backgroundColor: '#665A47',
  },
  '&:focus': {
    backgroundColor: '#CC1400',
  },

  fontFamily: 'Johnson Text',
  fontWeight: 400,
  fontSize: '12px',

}

const GroupsList = ({ groups, areGroupsLoading }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [sortBy, setSortBy] = useState('displayName')
  const [sortOrder, setSortOrder] = useState('asc')

  React.useEffect(() => {
    setPage(0)
  }, [groups])

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const handleSort = (property) => {
    const newOrder = sortBy === property && sortOrder === 'asc' ? 'desc' : 'asc'
    setSortBy(property)
    setSortOrder(newOrder)
  }

  const sortedGroups = useMemo(
    () => sortGroups({ groups, sortOrder, sortBy }),
    [groups, sortOrder, sortBy]
  )

  const renderTableHead = () => (
    <TableRow
      sx={{
        '& th': {
          backgroundColor: '#F5F5F5',
        },
      }}
    >
      <TableCell className={styles.groupTableHeader}>{t("view-edit-column-group-id")}</TableCell>
      <TableCell className={styles.groupTableHeader}>
        <TableSortLabel
          className={styles.groupTableHeader}
          active={sortBy === 'displayName'}
          direction={sortOrder}
          onClick={() => handleSort('displayName')}
        >
          {t("view-edit-column-group-name")}
        </TableSortLabel>
      </TableCell>
      <TableCell className={styles.groupTableHeader}>{t("view-edit-column-group-update-description")} </TableCell>
      <TableCell className={styles.groupTableHeader}>{t("view-edit-column-group-edit-members")} </TableCell>
      {/* <TableCell className={styles.groupTableHeader} ></TableCell> */}
    </TableRow>
  )

  const handleEditGroup = (e, groupId, navigate) => {
    e.stopPropagation()
    navigate(`/edit-group/${groupId}`)
  }

  const handleEditGroupMembers = (e, groupId) => {
    e.stopPropagation()
    navigate(`/edit-members/${groupId}`)
  }

  const renderTableBody = () => {
    const handleTableRowClick = (event, groupId) => {
      event.stopPropagation()
      const nodeName = event.target?.nodeName
      if (nodeName?.toLowerCase() == 'td') {
        navigate(`/view-group/${groupId}`)
      }
    }

    return sortedGroups
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((group) => (
        <TableRow
          className={styles.tableBodyRow}
          key={group.id}
          onClick={(event) => handleTableRowClick(event, group.id)}
        >
          <TableCell sx={{ fontSize: '16px', color: '#000' }} className={styles.tableCell}>
            {group.id}
          </TableCell>
          <TableCell sx={{ fontSize: '16px', color: '#000' }} className={styles.tableCell}>
            {group.displayName}
          </TableCell>
          <TableCell sx={{fontSize: '16px' }}>
            <Button
              onClick={e => handleEditGroup(e, group.id, navigate)}
              variant="contained"
              className="primary-btn"
              disableElevation
              sx={{ ...editStyle }}
            >
              {t('view-edit-column-group-edit-button')}
            </Button>
          </TableCell>
          <TableCell sx={{fontSize: '16px' }}>
            <Button
              onClick={e => handleEditGroupMembers(e, group.id)}
              variant="contained"
              className="primary-btn"
              disableElevation
              sx={{
                color: 'rgba(0, 0, 0, 0.87)',
                width: '155px',
                backgroundColor: 'rgba(98, 81, 55, 0.1)',
                '&:hover': {
                  backgroundColor: 'rgba(102, 90, 71, 0.20)',
                },
                '&:disabled': {
                  backgroundColor: '#665A47',
                },
                '&:focus': {
                  backgroundColor: 'rgba(102, 90, 71, 0.20)',
                },
                fontFamily: 'Johnson Text',
                fontWeight: 600,
                fontSize: '12px',
              }}
            >
              {t('view-edit-column-group-member-button')}
            </Button>
          </TableCell>
          {/* <TableCell className={styles.tableCell}>
            <Button
              onClick={(e) => handleEditGroup(e, group.id, navigate)}
              variant="contained"
              className="primary-btn"
            >
              Edit
            </Button>
          </TableCell> */}
        </TableRow>
      ))
  }

  const renderTable = () => (
    <div className={styles.container}>
      {(areGroupsLoading || groups.length > 0) && (
      <div>
        <p className={styles.results}>{groups.length} {t('results')}</p>
        <TableContainer className={styles.tableContainer}>
          <Table stickyHeader>
            <TableHead>{renderTableHead()}</TableHead>

            <TableBody>
              {areGroupsLoading ? (
                <TableRow>
                  <TableCell sx={{ border: 'none' }} colSpan={6}>
                    <div className={styles.loaderContainer}>
                      <div className={styles.loading}>{t('loading')}</div>
                      <CircularProgress
                        sx={{
                              color: 'black',
                            }}
                      />
                    </div>
                  </TableCell>
                </TableRow>
                  ) : (
                    renderTableBody()
                  )}
            </TableBody>
          </Table>
        </TableContainer>
        {groups.length > 10 && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={groups.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
            )}
      </div>
        )}
    </div>
    )

  return <>{renderTable()}</>
}

export default GroupsList
